import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Moment } from 'moment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'chart-date-interval-selector',
  templateUrl: './chart-date-interval-selector.component.html',
  styleUrls: ['./chart-date-interval-selector.component.scss']
})
export class ChartDateIntervalSelectorComponent implements OnChanges {

  @Input() dates: { from: Moment, to: Moment };
  @Output() activeButtonEvent = new EventEmitter<string>();
  buttonState: {
    activeButton: 'DAY' | 'WEEK' | 'MONTH';
    disabledButtons: {
      DAY: boolean;
      WEEK: boolean;
      MONTH: boolean;
    }
  } = {
    activeButton: 'WEEK',
    disabledButtons: {
      DAY: false,
      WEEK: true,
      MONTH: true
    }
  };

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!changes || !changes.dates || !changes.dates.currentValue || !changes.dates.currentValue.from || !changes.dates.currentValue.to) {
      return;
    }

    if (changes.dates.currentValue === changes.dates.previousValue) {
      return;
    }

    this.setAvailableDateInterval();
    this.activeButtonChange(this.buttonState.activeButton, changes.dates.firstChange);
  }

  public activeButtonChange(dateInterval: 'DAY' | 'WEEK' | 'MONTH', isFirstChange?: boolean): void {
    if (this.buttonState.activeButton === dateInterval && !isFirstChange) {
      return;
    }

    this.buttonState.activeButton = dateInterval;
    this.activeButtonEvent.emit(dateInterval);
  }

  private setAvailableDateInterval(): void {
    this.setDisabledButtons();
    this.enableFirstAvailableButton();
  }

  private setDisabledButtons(): void {
    const { from, to } = this.dates;
    const daysInterval = to.diff(from, 'days');
    const mountInterval = to.diff(from, 'months');

    this.buttonState.disabledButtons = {
      DAY: true,
      WEEK: true,
      MONTH: true
    };

    if (daysInterval <= 20) {
      this.buttonState.disabledButtons.DAY = false;
    }

    if (mountInterval <= 3) {
      this.buttonState.disabledButtons.WEEK = false;
    }

    if (mountInterval > 1 ) {
      this.buttonState.disabledButtons.MONTH = false;
    }
  }

  private enableFirstAvailableButton(): void {
    for (const key in this.buttonState.disabledButtons) {
      if (this.buttonState.disabledButtons.hasOwnProperty(key) && !this.buttonState.disabledButtons[key]) {
        this.activeButtonChange(key as 'DAY' | 'WEEK' | 'MONTH');
        break;
      }
    }
  }
}
